import NAME from "./constants";

export const getNotes = store => store[NAME].notes || [];
export const getUserLabels = store => store[NAME].userLabels || [];
export const isLoading = store => store[NAME].loading || false;
export const getSendingMail = store => store[NAME].sendingMail;
export const getDateFormat = store => store[NAME].dateFormat;
export const getCommentsForNote = store => store[NAME].commentsForNote;
export const getGroups = store => store[NAME].groups;
export const getSocietyPeople = store => store[NAME].societyPeople;